module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h8', [_vm._v("Welcome to Pair'd")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "slack_account"
  }, [_c('b-form-fieldset', {
    attrs: {
      "description": "Link it to your Slack account.",
      "label": "Enter your Slack account",
      "feedback": _vm.feedback_slack,
      "state": _vm.state_slack,
      "label-cols": 3
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state
    },
    model: {
      value: (_vm.slack),
      callback: function($$v) {
        _vm.slack = $$v
      },
      expression: "slack"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "profile_name"
  }, [_c('b-form-fieldset', {
    attrs: {
      "description": "Choose your own nickname.",
      "label": "Enter your profile name",
      "feedback": _vm.feedback_pname,
      "state": _vm.state_pname,
      "label-cols": 3
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state
    },
    model: {
      value: (_vm.pname),
      callback: function($$v) {
        _vm.pname = $$v
      },
      expression: "pname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "password_prompt"
  }, [_c('h8', [_vm._v("Enter your password ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "VuePassword",
    attrs: {
      "title": _vm.feedback_password
    }
  }, [_c('div', {
    staticClass: "VuePassword__Input"
  }, [_c('input', {
    ref: "input",
    class: _vm.classes,
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "id": _vm.id,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "required": _vm.required,
      "pattern": _vm.pattern
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updatePassword($event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.disableToggle) ? _vm._t("password_toggle", [_c('a', {
    staticClass: "VuePassword__Toggle",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.togglePassword
    }
  }, [(_vm.type === 'password') ? _c('svg', {
    staticClass: "VuePassword__Toggle__Icon",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228v0zM16 13c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'text') ? _c('svg', {
    staticClass: "VuePassword__Toggle__Icon",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M29.561 0.439c-0.586-0.586-1.535-0.586-2.121 0l-6.318 6.318c-1.623-0.492-3.342-0.757-5.122-0.757-6.979 0-13.028 4.064-16 10 1.285 2.566 3.145 4.782 5.407 6.472l-4.968 4.968c-0.586 0.586-0.586 1.535 0 2.121 0.293 0.293 0.677 0.439 1.061 0.439s0.768-0.146 1.061-0.439l27-27c0.586-0.586 0.586-1.536 0-2.121zM13 10c1.32 0 2.44 0.853 2.841 2.037l-3.804 3.804c-1.184-0.401-2.037-1.521-2.037-2.841 0-1.657 1.343-3 3-3zM3.441 16c1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 1.715 0.54 3.304 1.459 4.607l-1.904 1.904c-1.639-1.151-3.038-2.621-4.114-4.323z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24 13.813c0-0.849-0.133-1.667-0.378-2.434l-10.056 10.056c0.768 0.245 1.586 0.378 2.435 0.378 4.418 0 8-3.582 8-8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.938 9.062l-2.168 2.168c0.040 0.025 0.079 0.049 0.118 0.074 1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303-1.208 0-2.403-0.149-3.561-0.439l-2.403 2.403c1.866 0.671 3.873 1.036 5.964 1.036 6.978 0 13.027-4.064 16-10-1.407-2.81-3.504-5.2-6.062-6.938z"
    }
  })]) : _vm._e()])], {
    toggle: _vm.togglePassword,
    type: _vm.type
  }) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "password_confirm"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Confirm your password",
      "feedback": _vm.feedback_confirm,
      "state": _vm.state_confirm,
      "label-cols": 3
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dietary"
  }, [_c('h8', [_vm._v(" Dietary Options ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('b-form-radio', {
    attrs: {
      "options": _vm.options,
      "feedback": _vm.feedback_dietary,
      "state": _vm.state_dietary
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "signup_button hvr-grow"
  }, [_c('b-button', {
    attrs: {
      "size": "big",
      "variant": "outline-success",
      "href": ""
    }
  }, [_vm._v("\n      Sign Up\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1806c717","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/signup.vue
// module id = 38
// module chunks = 0